/**
 * Cross-subdomain URLs. Marketing lives at bookaburra.com; the booking
 * app at app.bookaburra.com. Any CTA that points users into the app
 * MUST use an absolute URL via this constant — relative paths 404 on
 * the marketing domain.
 */
export const APP_URL = 'https://app.bookaburra.com';

/** Convenience helper for /signup with an optional query string. */
export function signupUrl(query?: Record<string, string>): string {
  const base = `${APP_URL}/signup`;
  if (!query || Object.keys(query).length === 0) return base;
  const params = new URLSearchParams(query);
  return `${base}?${params.toString()}`;
}
